// Instructions:
//   - Add 'copy-text' id to the value you want written to the clipboard.
//   - Add the class 'js-copy-text' to any button you want to activate the copyText component.
//   - Set the 'data-copy-target' attribute on the button to the ID of the element containing the text to copy ie: id="copy-text".
//   - Optionally set data-copy-feedback="icon" on icon-only buttons to flash a check mark instead of the "Copied" label.
//
// Example:
// <p>
//     Hello World! Copy this link:
//     <a href="http://superhivemarket.com/?ref=<%= @affiliate.id %>" id="copy-text">http://superhivemarket.com/?ref=<%= @affiliate.id %></a>

//     <button class="btn btn-primary btn-sm js-copy-text" data-copy-target="copy-text">
//         <i class="fa fa-solid fa-copy"></i> Copy
//     </button>
// </p>
//

function copyText(event) {
  event.preventDefault()
  var $btn = $(event.currentTarget)
  // A second click during the feedback would capture the "Copied" state as the original
  if ($btn.data("copy-pending")) return
  var textToCopyId = $btn.data("copy-target")
  var $originalHTML = $btn.html()
  var originalClass = $btn.attr("class")
  var iconFeedback = $btn.data("copy-feedback") === "icon"
  var $textToCopyElement = $("#" + textToCopyId)
  var textToCopy =
    $textToCopyElement.attr("href") ||
    $textToCopyElement.text() ||
    $textToCopyElement.val()

  navigator.clipboard.writeText(textToCopy).then(function () {
    $btn.data("copy-pending", true)
    if (iconFeedback) {
      $btn.html('<i class="fas fa-check"></i>')
    } else {
      $btn.html('<i class=""></i> Copied')
      $btn.removeClass("btn-primary").addClass("btn-success")
    }
    $btn.css("cursor", "not-allowed")

    setTimeout(function () {
      $btn.html($originalHTML)
      $btn.attr("class", originalClass)
      $btn.css("cursor", "pointer")
      $btn.prop("disabled", false)
      $btn.removeData("copy-pending")
    }, 1000)
  })
}

// Delegated so buttons injected after page load (e.g. the asset-library modal
// arriving with the XHR-loaded product assets tab) work without rebinding.
$(document).on("click", ".js-copy-text", copyText)
